export default "__VITE_ASSET__CvkHDES6__"